"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const notification_1 = __importDefault(require("@kawaui/notification"));
const errors_1 = require("../utils/errors");
const Notification = ({ open, onClose, container, errorCode, i18n, children }) => {
    const props = (0, errors_1.getNotificationProps)(errorCode);
    return ((0, jsx_runtime_1.jsx)(notification_1.default, Object.assign({}, props, { open: open, onClose: onClose, container: container, children: (children && i18n(String(children))) || undefined })));
};
exports.default = Notification;
